import { takeLatest, call, put } from "redux-saga/effects";
import {
  FORGOT_PASSWORD_REQUEST,
  forgotPasswordSuccess,
  forgotPasswordFailure,
} from "../actions/forgotPasswordActions";
import { forgotPassword } from "../../../services/accIqService";

function* forgotPasswordSaga(action) {
  try {
    const response = yield call(forgotPassword, action.payload);

    yield put(
      forgotPasswordSuccess(
        response?.message ||
          "Password reset request sent to support team successfully"
      )
    );
  } catch (error) {
    yield put(
      forgotPasswordFailure(
        error?.response?.data?.message || "Something went wrong"
      )
    );
  }
}

export function* watchForgotPassword() {
  yield takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordSaga);
}
